import type { NextPage } from 'next';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import TradeInCompoment from '@/components/TradeIn';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/trade-in';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import { getAppSession } from '@/utils/appGetToken';

const TradeIn: NextPage<any> = ({ SEO }) => {
    const { t } = useLang('seo');
    const { isApp } = useGlobal();
    const { locale } = getLocal();

    if (isApp) {
        // efBridge.registerHandler('getAppMsg', (res) => {
        //     if (!res) return;
        //     const dataSet = {
        //         token: res.token.replace('Bearer ', ''),
        //         user: {},
        //     };
        //     onLogin(dataSet);
        // });
        const token = getAppSession();
        const dataSet = {
            token,
            user: {},
        };
        onLogin(dataSet);
    }

    return (
        <>
            <SEO title={t('title')} description={t('desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <PageLayout hideFooter={isApp} hideHeader={isApp}>
                <TradeInCompoment />
            </PageLayout>
        </>
    );
};

export default TradeIn;
